module.exports = __webpack_public_path__ + "static/media/ng-post-top.d4614384.png";